import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MetaNavItem, NavMenuType, PrimaryNavItem } from '@hdms/shared/page-frame/types';

@Component({
  selector: 'shrd-pf-ft-burger-menu-secondary-header',
  templateUrl: './burger-menu-secondary-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BurgerMenuSecondaryHeaderComponent {
  @Input() selectedItem: PrimaryNavItem | MetaNavItem;
  readonly menuTypes = NavMenuType;
}
